import React, {useState} from 'react'
import './executive.css'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Inputfield from '../../../Components/InputField/Inputfield'
import { IoChevronDown, IoChevronForwardSharp } from 'react-icons/io5';
import EditorToolbar, { modules, formats } from "../../../Components/EditorToolbar";
import { useCookies } from 'react-cookie';
import axios from 'axios';

const Executive = ({empselect, sendnotice}) => {
  const API = 'https://staging.sabrecwa.com/staff'
  const [cookies] = useCookies(['Token']);

  const [value, setValue] = useState('');
  const [selectedemp, setSelectedemp] = useState([])
  const [previewclick, setPreviewclick] = useState(false)
  const [execobj, setExecobj] = useState({
    email: '',
    name: '',
    qualification: '',
    positionheld: '',
    aboutus: ''
  })

  selectedemp[0] !== undefined && delete selectedemp[0].CreatedAt
  selectedemp[0] !== undefined && delete selectedemp[0].DeletedAt
  selectedemp[0] !== undefined && delete selectedemp[0].UpdatedAt
  selectedemp[0] !== undefined && delete selectedemp[0].can_login
  selectedemp[0] !== undefined && delete selectedemp[0].isOnDisplay

  let newstaffArray = []
  empselect.allStaffs.map(staffObj => (
    newstaffArray.push({ID: staffObj.ID, name: staffObj.first_name + ' ' + staffObj.last_name})
  ))

  const handleCountryhead = (incoming) =>{
    let selected_employee = empselect.allStaffs.filter((empobj) => (
      empobj.ID === incoming
    ))

    setSelectedemp(selected_employee)
    setExecobj({
      ...execobj, 
      email : selected_employee[0].email, 
      name : selected_employee[0].first_name + ' ' + selected_employee[0].last_name
    })
  }

  const handleSocialFocus = () =>{
    setPreviewclick(!previewclick)
  }

  const handleSubmit = async(e) =>{
    e.preventDefault()
    sendnotice({
      action: "load",
      text: 'Uploading Data...'
    })
    
      const executiveObj = {
        email: execobj.email,
        executive_name: execobj.name,
        qualifications: execobj.qualification,
        position_held: execobj.positionheld,
        brief_about: value
      }

      console.log(executiveObj)

      try {
        var config = {
          method: 'POST',
          url: `${API}/hr/create/exec`,
          data: executiveObj,
          headers: { 
            Authorization: "Bearer " + cookies.Token
          }
        };

        await axios(config).then((response) => {
          if(response.data.success === true){
            // do something
            sendnotice({
              action: "success",
              text: response.data.message,
            })
          }
        });
      } catch(e){
        sendnotice({
          action: "",
          text: ''
        })
      }
  }

  const handleChange = (e) =>{
    const {name, value} = e.target
    setExecobj({...execobj, [name]: value})
  }

  return (
    <div className='appr-web-executive-container'>
      <div className="exec_adduser_title">
        <span>Add New Executives</span>
      </div>

      <form onSubmit={handleSubmit} className="exec_adduser_body">
        <div className="exec_adduser_body_row">
          <img id='exec_adduser_profile-img-container' src={selectedemp[0] !== undefined ? selectedemp[0].image_url : ""} alt='pictures'/>
        </div>


        <div className="exec_adduser_body_row_1">
          <span>Executive's Name: </span>
          <Inputfield EmployeeJson={newstaffArray} unithead={handleCountryhead} fieldlabel="" placehold="Select Employee as Executive..." typeid="headsdropdwn"/>
        </div>

        <div className="exec_adduser_body_row_1">
          <span>Qualifications: </span>
          <input name='qualification' value={execobj.qualification} onChange={handleChange} id='executive-title-field' placeholder='e.g. MIT, COREN, PhD.'/>
        </div>

        <div className="exec_adduser_body_row_1">
          <span>Position Held: </span>
          <input name='positionheld' value={execobj.positionheld} onChange={handleChange} id='executive-title-field' placeholder='e.g Group Chair'/>
        </div>

        <div className="exec_adduser_body_row_1">
          <span>Brief About: </span>
          <div id='executive-text-area'>
            <EditorToolbar toolbarId={'t2'} />
            <ReactQuill 
              theme="snow" 
              value={value} 
              onChange={setValue} 
              className='executive-title'
              modules={modules('t2')}
              formats={formats}
            />
          </div>
        </div>

        <div className="exec_adduser_body_row_1">
          <span></span>
          <button type='submit' id='form-submit-butn'>Submit</button>
        </div>
      </form>

      <div className="website-exec-preview-container">
        <div className="website-exec-preview" onClick={handleSocialFocus}>
          <span>Web Preview</span>
          {previewclick ? <IoChevronDown id="chevron-down" onClick={handleSocialFocus}/> :
          <IoChevronForwardSharp id="chevron-down" onClick={handleSocialFocus}/>}
        </div>

        <div className="ql-editor">
          <div className={previewclick === false ? "website-exec-preview-body" : "website-exec-preview-bdy"} dangerouslySetInnerHTML={{ __html: value}}/>
        </div>
      </div>
    </div>
  )
}

export default Executive;